export const CSS_CLASSES = {
  AVATAR_ROOT: "avatar",
  AVATAR_SIZE_LARGE: "avatar-size-large",
  AVATAR_SIZE_SMALL: "avatar-size-small",
  AVATAR_COLOR_INTERACTIVE: "avatar-color-interactive",
  AVATAR_COLOR_PRIMARY: "avatar-color-primary",
  AVATAR_VARIANT_LIGHT: "avatar-variant-light",
  AVATAR_VARIANT_DARK: "avatar-variant-dark",
  AVATAR_INITIALS: "avatar-initials",
};
